<script>
import http from "@/helpers/http";
import Modal from "@/helpers/modal";
import Alert from "@/helpers/alert";

export default {
  name: "SurveySettingModal",
  data() {
    return {
      sendType: {
        "both": "Ambos",
        "whatsapp": "WhatsApp",
        "email": "E-mail"
      },
      profPlaces: [],
    }
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
  },
  mounted() {
    this.getSettings();
  },
  methods: {
    getSettings() {
      http.get(`/places/${this.place.id_place}/surveys/settings`).then(response => {
        this.profPlaces = response.data;
      });
    },
    updateSettings() {
      http.put(`/places/${this.place.id_place}/surveys/settings`, {'prof_place': this.profPlaces}).then(() => {
        this.getSettings();

        Alert.success('Configuração atualizada com sucesso.');
        Modal.toggle('#modalSurveySettings');
      });
    },
    closeModal() {
      Modal.toggle('#modalSurveySettings');
    }
  }
}
</script>

<template>
  <div class="modal fade" id="modalSurveySettings"
       tabindex="-1" aria-labelledby="modalSurveySettings" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <form @submit.prevent="updateSettings">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="exampleModalLabel">Configurações</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <table class="table">
              <thead>
              <tr>
                <th>Profissional</th>
                <th>Habilitar pesquisas?</th>
                <th>Tipo de envio</th>
              </tr>
              </thead>
              <tbody>
                <tr v-for="profPlace in profPlaces">
                  <td>
                    <input type="text" class="form-control form-control-sm" v-model="profPlace.prof_name" disabled>
                  </td>
                  <td style="width: 10%;">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="enable_survey"
                             v-model="profPlace.enable_survey">
                    </div>
                  </td>
                  <td>
                    <select v-model="profPlace.send_type" class="form-control form-control-sm required form-control-solid"
                            required>
                      <option :value="type" :key="type" v-for="(typeDsc, type) in sendType">
                        {{ typeDsc }}
                      </option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer mt-3">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cancelar</button>
            <button type="submit" class="btn btn-primary">
              Salvar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>